import styled from 'styled-components';

export const TravelContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ArrowsContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: 0 8px 0 8px;
  padding-bottom: 10px;

  & > svg {
    margin-bottom: -8px !important;
  }
`;

export const TravelInfo = styled.span`
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.25;
  letter-spacing: normal;
  text-align: center;
  color: ${({ theme }) => theme.flightsHeader.color};
`;

export const DateInfo = styled.span`
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  text-align: center;
  color: ${({ theme }) => theme.flightsHeader.infoColor};
`;
